// @flow
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getTopNonAcknowledgedError } from 'common/redux/selectors/errorSelector';
import { ErrorHandler } from 'common/components/core/snackbar/ErrorHandler';

const AppErrorHandler = (): React.Node => {
    const error = useSelector(state => getTopNonAcknowledgedError(state));
    return error && error.message ? <ErrorHandler error={error} /> : null;
};

export default AppErrorHandler;
